import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Modal, Button, ModalHeader, ModalBody, ModalFooter, Row } from 'reactstrap';
import entityComposition from '../../common/classes/entityComposition';
import DateTimePicker from '../../common/controls/dateTimePicker';
import MultiPicker from '../../common/controls/multiPicker';
const DashboardFilterModal = _ref => {
  let _ref$jobs = _ref.jobs,
    propsJobs = _ref$jobs === void 0 ? [] : _ref$jobs,
    jobSelectDashboardActions = _ref.jobSelectDashboardActions,
    jobSelectDashboard = _ref.jobSelectDashboard,
    onFilter = _ref.onFilter,
    onHide = _ref.onHide,
    propsStart = _ref.start,
    propsStop = _ref.stop,
    show = _ref.show;
  const _useState = useState(propsStart),
    _useState2 = _slicedToArray(_useState, 2),
    start = _useState2[0],
    setStart = _useState2[1];
  const _useState3 = useState(propsStop),
    _useState4 = _slicedToArray(_useState3, 2),
    stop = _useState4[0],
    setStop = _useState4[1];
  const _useState5 = useState(propsJobs),
    _useState6 = _slicedToArray(_useState5, 2),
    jobs = _useState6[0],
    setJobs = _useState6[1];
  const handleCancel = () => onHide();
  const handleChangeJobs = values => setJobs(values);
  const handleChangeStart = value => setStart(value);
  const handleChangeStop = value => setStop(value);
  const handleFilter = () => onFilter({
    jobs,
    start,
    stop
  });
  const updateDisabled = !(start && stop);
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: show,
    toggle: handleCancel
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    closebutton: "true",
    "data-testid": "t-dfm-title"
  }, "Dashboard Filters"), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement(DateTimePicker, {
    onChange: handleChangeStart,
    label: "Start",
    defaultValue: start
  })), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement(DateTimePicker, {
    onChange: handleChangeStop,
    label: "Stop",
    defaultValue: stop
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(MultiPicker, {
    label: "Jobs",
    labelKey: "jobNumber",
    valueKey: "id",
    entity: jobSelectDashboard,
    entityActions: jobSelectDashboardActions,
    values: jobs,
    returnValueKey: "id",
    placeholder: "All",
    onChange: handleChangeJobs
  })))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    disabled: updateDisabled,
    color: "primary",
    onClick: handleFilter,
    className: "tqc-control",
    "data-testid": "t-dfm-updateButton"
  }, "Update"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleCancel,
    className: "tqc-control",
    "data-testid": "t-dfm-cancelButton"
  }, "Cancel")));
};
DashboardFilterModal.propTypes = {
  jobSelectDashboard: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({})),
    loading: PropTypes.bool
  }).isRequired,
  jobSelectDashboardActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  jobs: PropTypes.arrayOf(PropTypes.shape({})),
  onFilter: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  start: PropTypes.string.isRequired,
  stop: PropTypes.string.isRequired
};
export { DashboardFilterModal as TestDashboardFilterModal };
export default entityComposition(DashboardFilterModal, ['jobSelectDashboard'], {});